module.exports = __webpack_public_path__ + "img/evmobility.33c85d7c.png";